export default __webpack_public_path__ + "static/media/i_pill_doctor_yay.a4a2516b.svg";